import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { AccountInterest } from '@/components/content/Account/parts/AccountInterest/parts/AccountInterest';
import { AccountInterestEmpty } from '@/components/content/Account/parts/AccountInterest/parts/AccountInterestEmpty';
import { AccountInterestModal } from '@/components/content/Account/parts/AccountInterest/parts/AccountInterestModal';
import { AccountInterestSkeleton } from '@/components/content/Account/parts/AccountInterest/parts/AccountInterestSkeleton';
import { Box, Typography } from '@mui/material';
import { useHobbies } from '@/data/Content/Hobbies';

type Props = ReturnType<typeof useHobbies>;

export const AccountHobbiesCard = ({
	hobbies,
	isLoadingHobbies,
	selectedUserHobbies,
	openHobbiesModal,
	onOpenHobbiesModal,
	onCloseHobbiesModal,
	isSubmittingHobbies,
	onUpdateUserHobbies,
	onToggleUserHobbies,
}: Props) => (
	<>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
			<Typography
				sx={{
					fontSize: 'var(--font-size-md)',
					fontWeight: 800,
					marginY: (theme) => theme.spacing(3),
				}}
			>
				HOBBIES
			</Typography>
			<DpButton
				variant="text"
				sx={{
					'&:disabled': {
						color: 'var(--color-gray-500)',
					},
				}}
				disabled={hobbies.length === 0}
				onClick={onOpenHobbiesModal}
			>
				Editar hobbies
			</DpButton>
		</Box>
		<Box id="account-hobbies" sx={{ width: '100%' }}>
			{isLoadingHobbies ? (
				<AccountInterestSkeleton />
			) : hobbies.length === 0 ? (
				<AccountInterestEmpty message="Aún no encontramos hobbies para ti." />
			) : (
				<AccountInterest
					interests={hobbies}
					selectedUserInterests={selectedUserHobbies}
					containerId="account-hobbies"
					variant="horizontal"
				/>
			)}
		</Box>

		{openHobbiesModal ? (
			<AccountInterestModal
				title="Hobbies"
				interests={hobbies}
				selectedUserInterests={selectedUserHobbies}
				isSubmittingInterests={isSubmittingHobbies}
				onToggleUserInterest={onToggleUserHobbies}
				onUpdateUserInterests={onUpdateUserHobbies}
				onClose={onCloseHobbiesModal}
				variant="horizontal"
			/>
		) : null}
	</>
);
